<div class="tw-block tw-grid tw-w-full tw-grid-cols-1 tw-items-start tw-gap-6 tw-p-6 tw-font-inter lg:tw-grid-cols-[minmax(0,1fr)_400px] lg:tw-gap-10">
  <section class="tw-min-w-0 tw-w-full tw-flex tw-flex-col tw-gap-5">
    <div class="tw-flex tw-items-center tw-gap-2">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.99739 1.66797C5.3949 1.66797 1.66406 5.3988 1.66406 10.0013C1.66406 11.5763 2.10156 13.0513 2.8624 14.308L2.11906 16.8346C2.07638 16.9797 2.07357 17.1336 2.11093 17.2801C2.14829 17.4267 2.22444 17.5604 2.33136 17.6673C2.43829 17.7743 2.57205 17.8504 2.71858 17.8878C2.86511 17.9251 3.01899 17.9223 3.16406 17.8796L5.69073 17.1363C6.98963 17.9222 8.47924 18.3367 9.99739 18.3346C14.5999 18.3346 18.3307 14.6038 18.3307 10.0013C18.3307 5.3988 14.5999 1.66797 9.99739 1.66797ZM8.11239 11.8871C9.79823 13.5721 11.4074 13.7946 11.9757 13.8155C12.8399 13.8471 13.6816 13.1871 14.0091 12.4213C14.0504 12.326 14.0654 12.2214 14.0525 12.1184C14.0396 12.0153 13.9993 11.9176 13.9357 11.8355C13.4791 11.2521 12.8616 10.833 12.2582 10.4163C12.1323 10.3292 11.9775 10.2943 11.8263 10.3188C11.6751 10.3434 11.5393 10.4255 11.4474 10.548L10.9474 11.3105C10.9211 11.3515 10.8801 11.3809 10.8329 11.3926C10.7856 11.4044 10.7357 11.3977 10.6932 11.3738C10.3541 11.1796 9.85989 10.8496 9.50489 10.4946C9.14989 10.1396 8.83989 9.66797 8.66573 9.35047C8.64413 9.31013 8.63789 9.26333 8.64816 9.21875C8.65842 9.17416 8.6845 9.1348 8.72156 9.10797L9.49156 8.5363C9.60145 8.44075 9.67236 8.30813 9.6908 8.16369C9.70924 8.01924 9.67392 7.87306 9.59156 7.75297C9.21823 7.2063 8.78323 6.5113 8.15239 6.05047C8.07098 5.99147 7.97561 5.95469 7.87567 5.94373C7.77573 5.93277 7.67466 5.94802 7.5824 5.98797C6.81573 6.3163 6.15239 7.15797 6.18406 8.0238C6.20489 8.59214 6.42739 10.2013 8.11239 11.8871Z"
          fill="#111928"
        />
      </svg>

      <h6 class="tw-m-0 tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-white">WhatsApp Integration</h6>
    </div>
    <p class="tw-text-sm tw-leading-6 tw-text-gray-500 dark:tw-text-gray-400">
      Send WhatsApp confirmation messages to your guests. Templates are pre configured and approved by META, for custom templates, please
      <button type="button" class="tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-text-[#1C64F2] hover:tw-underline" (click)="openSupportModal()">
        request support</button
      >.
    </p>

    <div
      class="tw-divide-y tw-divide-gray-200 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white dark:tw-divide-gray-600 dark:tw-border-gray-600 dark:tw-bg-gray-800"
    >
      @for (flag of flags; track flag.name) {
      <label class="tw-m-0 tw-flex tw-min-h-[75px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-3 tw-px-3 tw-py-3 lg:tw-h-[75px] lg:tw-gap-4 lg:tw-px-4 lg:tw-py-0">
        <span class="tw-min-w-0">
          <span class="tw-m-0 tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-900 dark:tw-text-white">{{ flag.title }}</span>
          <span class="tw-m-0 tw-mt-0.5 tw-block tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400">{{ flag.description }}</span>
        </span>
        <span class="tw-inline-flex tw-shrink-0">
          <input
            type="checkbox"
            class="tw-peer tw-sr-only"
            role="switch"
            [attr.aria-label]="flag.title"
            [formControl]="whatsappControl(flag.name)"
            [attr.aria-checked]="whatsappControl(flag.name).value"
          />
          <span
            class="tw-flex tw-h-5 tw-w-10 tw-items-center tw-rounded-full tw-bg-gray-200 tw-px-[2px] tw-transition-colors peer-checked:tw-justify-end peer-checked:tw-bg-[#1C64F2] dark:tw-bg-gray-600"
          >
            <span class="tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow-sm"></span>
          </span>
        </span>
      </label>
      }
    </div>

    <div class="tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-border-[#A7CCFE] tw-bg-[#ECF5FF] tw-px-4 tw-py-2 dark:tw-border-blue-800 dark:tw-bg-blue-900/30">
      <svg class="tw-h-5 tw-w-5 tw-shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <g clip-path="url(#wa-info-note)">
          <path
            d="M10 0C8.21997 0 6.47991 0.527841 4.99987 1.51677C3.51983 2.50571 2.36628 3.91131 1.68509 5.55585C1.0039 7.20038 0.82567 9.00998 1.17294 10.7558C1.5202 12.5016 2.37737 14.1053 3.63604 15.364C4.89472 16.6226 6.49836 17.4798 8.24419 17.8271C9.99002 18.1743 11.7996 17.9961 13.4442 17.3149C15.0887 16.6337 16.4943 15.4802 17.4832 14.0001C18.4722 12.5201 19 10.78 19 9C18.9974 6.61385 18.0483 4.32619 16.3611 2.63893C14.6738 0.951673 12.3861 0.00262044 10 0ZM9.55 3.6C9.81701 3.6 10.078 3.67918 10.3 3.82752C10.522 3.97585 10.6951 4.1867 10.7972 4.43338C10.8994 4.68006 10.9262 4.9515 10.8741 5.21337C10.822 5.47524 10.6934 5.71579 10.5046 5.90459C10.3158 6.09339 10.0752 6.22197 9.81338 6.27406C9.5515 6.32615 9.28006 6.29941 9.03338 6.19724C8.7867 6.09506 8.57586 5.92202 8.42752 5.70002C8.27918 5.47801 8.2 5.217 8.2 4.95C8.2 4.59196 8.34223 4.24858 8.59541 3.9954C8.84858 3.74223 9.19196 3.6 9.55 3.6ZM11.8 13.5H8.2C7.96131 13.5 7.73239 13.4052 7.56361 13.2364C7.39482 13.0676 7.3 12.8387 7.3 12.6C7.3 12.3613 7.39482 12.1324 7.56361 11.9636C7.73239 11.7948 7.96131 11.7 8.2 11.7H9.1V9H8.2C7.96131 9 7.73239 8.90518 7.56361 8.73639C7.39482 8.56761 7.3 8.33869 7.3 8.1C7.3 7.8613 7.39482 7.63238 7.56361 7.4636C7.73239 7.29482 7.96131 7.2 8.2 7.2H10C10.2387 7.2 10.4676 7.29482 10.6364 7.4636C10.8052 7.63238 10.9 7.8613 10.9 8.1V11.7H11.8C12.0387 11.7 12.2676 11.7948 12.4364 11.9636C12.6052 12.1324 12.7 12.3613 12.7 12.6C12.7 12.8387 12.6052 13.0676 12.4364 13.2364C12.2676 13.4052 12.0387 13.5 11.8 13.5Z"
            fill="#1C64F2"
          />
        </g>
        <defs>
          <clipPath id="wa-info-note">
            <rect width="18" height="18" fill="white" transform="translate(1)" />
          </clipPath>
        </defs>
      </svg>
      <p class="tw-m-0 tw-text-[12px] tw-leading-5 tw-text-[#3D4756] dark:tw-text-blue-100">
        Only guests with a mobile number (with country code) will receive WhatsApp messages. Changes apply after you click Save.
      </p>
    </div>
  </section>

  <section class="tw-w-full">
    <p class="tw-m-0 tw-text-sm tw-font-lg tw-text-gray-900 dark:tw-text-white">Template preview</p>
    <div class="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2">
      <div
        #typeSwitch
        class="tw-relative tw-inline-flex tw-h-11 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white dark:tw-border-gray-600 dark:tw-bg-gray-800"
        role="group"
        aria-label="Template type"
      >
        <span
          data-segment-thumb
          class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-bg-blue-50 data-[ready=true]:tw-transition-[transform,width] data-[ready=true]:tw-duration-200 data-[ready=true]:tw-ease-out"
          [style.width]="'var(--segment-w, 0px)'"
          [style.transform]="'translateX(var(--segment-x, 0px))'"
        ></span>
        <button
          type="button"
          data-segment="confirmation"
          class="tw-relative tw-z-10 tw-border-0 tw-bg-transparent tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-duration-200"
          [ngClass]="{
            'tw-text-blue-600': templateType() === 'confirmation',
            'tw-text-gray-500 dark:tw-text-gray-400': templateType() !== 'confirmation'
          }"
          (click)="selectTemplateType('confirmation')"
        >
          Confirmation
        </button>
        <button
          type="button"
          data-segment="reminder"
          class="tw-relative tw-z-10 tw-border-0 tw-bg-transparent tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-duration-200"
          [ngClass]="{
            'tw-text-blue-600': templateType() === 'reminder',
            'tw-text-gray-500 dark:tw-text-gray-400': templateType() !== 'reminder'
          }"
          (click)="selectTemplateType('reminder')"
        >
          Reminder
        </button>
      </div>
      <div
        #langSwitch
        class="tw-relative tw-inline-flex tw-h-11 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white dark:tw-border-gray-600 dark:tw-bg-gray-800"
        role="group"
        aria-label="Template language"
      >
        <span
          data-segment-thumb
          class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-bg-blue-50 data-[ready=true]:tw-transition-[transform,width] data-[ready=true]:tw-duration-200 data-[ready=true]:tw-ease-out"
          [style.width]="'var(--segment-w, 0px)'"
          [style.transform]="'translateX(var(--segment-x, 0px))'"
        ></span>
        <button
          type="button"
          data-segment="en"
          class="tw-relative tw-z-10 tw-border-0 tw-bg-transparent tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-duration-200"
          [ngClass]="{
            'tw-text-blue-600': templateLang() === 'en',
            'tw-text-gray-500 dark:tw-text-gray-400': templateLang() !== 'en'
          }"
          (click)="selectTemplateLang('en')"
        >
          English
        </button>
        <button
          type="button"
          data-segment="ar"
          class="tw-relative tw-z-10 tw-border-0 tw-bg-transparent tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-duration-200"
          [ngClass]="{
            'tw-text-blue-600': templateLang() === 'ar',
            'tw-text-gray-500 dark:tw-text-gray-400': templateLang() !== 'ar'
          }"
          (click)="selectTemplateLang('ar')"
        >
          Arabic
        </button>
      </div>
    </div>

    <div class="tw-mt-4 tw-overflow-hidden tw-rounded-xl tw-border tw-border-gray-200">
      <div class="tw-bg-white">
        <div class="tw-flex tw-h-14 tw-items-center tw-gap-2 tw-bg-[#075E54] tw-px-4">
          <svg class="tw-h-8 tw-w-8 tw-shrink-0" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#FFB500" />
            <g clip-path="url(#wa-preview-logo)">
              <path
                d="M12.8749 20.4999C13.3581 20.4999 13.7497 20.1082 13.7497 19.6249C13.7497 19.1417 13.3581 18.75 12.8749 18.75C12.3917 18.75 12 19.1417 12 19.6249C12 20.1082 12.3917 20.4999 12.8749 20.4999Z"
                fill="#172435"
              />
              <path
                d="M19.1249 20.4999C19.6081 20.4999 19.9997 20.1082 19.9997 19.6249C19.9997 19.1417 19.6081 18.75 19.1249 18.75C18.6417 18.75 18.25 19.1417 18.25 19.6249C18.25 20.1082 18.6417 20.4999 19.1249 20.4999Z"
                fill="#172435"
              />
              <path
                d="M18.4832 15.9863L11.3749 16.5001C11.1492 16.5001 11 16.3037 11 16.0778V9.44176C11 8.63827 11.9434 8.20528 12.5542 8.72862L19.0957 14.3331C19.7587 14.9009 19.3565 15.9864 18.4832 15.9864V15.9863Z"
                fill="#141414"
              />
              <path
                d="M11.4997 16.5001H11.9997C13.5863 16.5001 15.0717 17.7604 15.0717 19.3466V20.8823H16.9513V19.5813C16.9513 17.8655 18.2822 16.5001 19.9991 16.5001H20.499C20.7217 16.5001 20.9997 16.2931 20.9997 16.0703V9.44263C20.9997 8.64016 20.0573 8.20716 19.4478 8.72935L11.2498 16.2501C10.9998 16.5001 11.3772 16.5001 11.4997 16.5001Z"
                fill="#172435"
              />
              <path
                d="M11.4155 23.5H20.5838C20.813 23.5 20.9993 23.3081 20.9993 23.0715V22.6785C20.9993 22.442 20.8131 22.25 20.5838 22.25H11.4155C11.1863 22.25 11 22.442 11 22.6785V23.0715C11 23.3081 11.1862 23.5 11.4155 23.5Z"
                fill="#172435"
              />
            </g>
            <defs>
              <clipPath id="wa-preview-logo">
                <rect width="10" height="15" fill="white" transform="translate(11 8.5)" />
              </clipPath>
            </defs>
          </svg>
          <div class="tw-min-w-0">
            <p class="tw-m-0 tw-flex tw-items-center tw-gap-1 tw-text-sm tw-font-semibold tw-text-white">
              MICEtribe ✓
              <!-- todo: add checkmark icon -->
              <!-- <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 16 16" aria-hidden="true">
                <circle cx="8" cy="8" r="8" fill="#25D366" />
                <path d="M4.5 8.2 6.7 10.4 11.5 5.6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg> -->
            </p>
            <p class="tw-m-0 tw-text-xs tw-leading-4 tw-text-white/80">Business account</p>
          </div>
        </div>
        <div class="tw-bg-[#ECE5DD] tw-min-h-[410px] tw-flex tw-items-center tw-p-4 sm:tw-p-8 lg:tw-p-12" [attr.dir]="templateLang() === 'ar' ? 'rtl' : 'ltr'">
          <div class="tw-rounded-xl tw-w-full tw-bg-white tw-p-2 tw-flex tw-flex-col">
            <div class="tw-flex tw-h-[110px] tw-items-center tw-justify-center tw-rounded-xl tw-bg-gray-800">
              <svg width="288" height="111" viewBox="0 0 288 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="288" height="111" rx="12" fill="#172437"/>
                <g clip-path="url(#clip0_19_42125)">
                <path d="M127.438 79.1998C129.999 79.1998 132.074 77.1368 132.074 74.5919C132.074 72.0469 129.999 69.9839 127.438 69.9839C124.877 69.9839 122.801 72.0469 122.801 74.5919C122.801 77.1368 124.877 79.1998 127.438 79.1998Z" fill="#FFB500"/>
                <path d="M160.559 79.1998C163.12 79.1998 165.196 77.1368 165.196 74.5919C165.196 72.0469 163.12 69.9839 160.559 69.9839C157.998 69.9839 155.922 72.0469 155.922 74.5919C155.922 77.1368 157.998 79.1998 160.559 79.1998Z" fill="#FFB500"/>
                <path d="M157.161 55.4278L119.487 58.1339C118.291 58.1339 117.5 57.0993 117.5 55.9097V20.9599C117.5 16.7282 122.5 14.4478 125.737 17.2041L160.407 46.7211C163.921 49.7115 161.789 55.4286 157.161 55.4286V55.4278Z" fill="#F09D00"/>
                <path d="M120.15 58.1331H122.799C131.209 58.1331 139.081 64.7706 139.081 73.1246V81.2125H149.043V74.3606C149.043 65.324 156.097 58.1331 165.196 58.1331H167.846C169.026 58.1331 170.499 57.043 170.499 55.8694V20.9637C170.499 16.7373 165.504 14.4569 162.274 17.207L118.825 56.8165C117.5 58.1331 119.5 58.1331 120.15 58.1331Z" fill="#FFB500"/>
                <path d="M119.702 95.0001H168.294C169.509 95.0001 170.496 93.9891 170.496 92.7432V90.6734C170.496 89.4275 169.509 88.4165 168.294 88.4165H119.702C118.487 88.4165 117.5 89.4275 117.5 90.6734V92.7432C117.5 93.9891 118.487 95.0001 119.702 95.0001Z" fill="#FFB500"/>
                </g>
                <defs>
                <clipPath id="clip0_19_42125">
                <rect width="53" height="79" fill="white" transform="translate(117.5 16)"/>
                </clipPath>
                </defs>
                </svg>
                
            </div>
            <div class="tw-mt-2 tw-px-1">
              @for (line of activeTemplate().lines; track line) {
              <p class="tw-mb-4 tw-text-xs tw-leading-4 tw-text-gray-700" [ngClass]="{ 'tw-text-start': templateLang() === 'ar' }">{{ line }}</p>
              }
            </div>
            <p class="tw-mb-0 tw-mt-[-10px] tw-px-2 tw-text-end tw-text-[10px] tw-leading-4 tw-text-gray-400">10:24</p>
            <div
              class="tw-mt-2 tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-border-t tw-border-gray-200 tw-py-2 tw-text-xs tw-font-medium tw-text-[#1C64F2]"
            >
              <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M14 5h5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19 5 10 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                <path d="M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
              {{ activeTemplate().action }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="tw-mb-0 tw-mt-3 tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400">
      WhatsApp templates are pre-approved by Meta, so the text can't be edited here. {{ '{{fields}}' }} are filled in per guest. The English or Arabic template is determined by the selected registration form language. Cost is
      <span class="tw-font-extrabold">{{ whatsappMessagePriceUsd }}$</span> per confirmation or reminder message.
    </p>
  </section>
</div>

@if (isSupportModalOpen()) {
<modal
  [id]="supportModalId"
  [header]="''"
  [showHeader]="false"
  [showHeaderDivider]="false"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-11/12 tw-max-w-[420px]'"
  [heightClass]="'tw-h-auto'"
>
  <div slot="body" class="tw-relative tw-flex tw-flex-col tw-items-center tw-px-2 tw-pb-2 tw-pt-1 tw-text-center tw-font-inter">
    <button type="button" class="tw-absolute tw-end-0 tw-top-0 tw-border-0 tw-bg-transparent tw-p-1 tw-text-gray-400" aria-label="Close" (click)="closeSupportModal()">
      <svg class="tw-h-3 tw-w-3" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M2 2l8 8M10 2 2 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
      </svg>
    </button>
    <div class="tw-mb-3 tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full dark:tw-bg-gray-700">
      <svg class="tw-h-5 tw-w-5" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <g clip-path="url(#wa-support-info)">
          <path
            d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z"
            fill="#9CA3AF"
          />
        </g> 
        <defs>
          <clipPath id="wa-support-info">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <p class="tw-m-0 tw-text-sm tw-leading-6 tw-text-gray-600 dark:tw-text-gray-300">
      WhatsApp templates can be customized on request, but each template must be approved by Meta and involves a cost. To proceed, please contact our support team.
    </p>
    <div class="tw-mt-5 tw-flex tw-items-center tw-gap-3">
      <button
        type="button"
        class="tw-rounded-lg tw-border-0 tw-bg-[#1C64F2] tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white disabled:tw-opacity-50"
        [disabled]="isContactingSupport()"
        (click)="contactSupport()"
      >
        Contact support
      </button>
      <button
        type="button"
        class="tw-rounded-md tw-border tw-border-gray-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-gray-200"
        (click)="closeSupportModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</modal>
}
